import React, { Component } from 'react';

export default class InputText extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    render() {
        const { type, ...rest } = this.props;
        return (
            <input
                type={type || 'text'}
                onChange={this.onChange}
                onBlur={this.onBlur}
                {...rest}
            />
        );
    }

    onChange(e) {
        this.props.onChange(e.target.value);
    }

    onBlur() {
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    }
}
